import { Cross, Users, Heart, Sun, Flame } from "lucide-react";
import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";

const ICONS = [Cross, Users, Heart, Sun, Flame];

const Values = () => {
  const { t } = useLanguage();
  const items = t.values.items;

  const cardClass =
    "relative group rounded-3xl border border-cream/15 bg-white/[0.05] p-8 lg:p-10 transition-all duration-500 hover:-translate-y-1 hover:border-gold/60 hover:bg-white/[0.08] overflow-hidden [&_h3]:!text-[#E5C76B] [&_p]:!text-cream/90 [&_svg]:!text-[#E5C76B]";

  return (
    <section id="values" className="relative py-24 lg:py-36 bg-anthracite text-cream overflow-hidden">
      <div className="pointer-events-none absolute top-1/3 left-1/2 -translate-x-1/2 w-[800px] h-[500px]" style={{ background: "radial-gradient(ellipse, rgba(198,156,34,0.1) 0%, transparent 60%)" }} />
      <div className="container-boe">
        <div className="max-w-2xl">
          <span className="section-eyebrow">{t.values.eyebrow}</span>
          <h2 className="mt-5 text-4xl md:text-5xl lg:text-6xl font-semibold text-cream leading-[1.05] tracking-tight">
            {t.values.title}
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6 md:auto-rows-[minmax(260px,auto)]">
          {items.map((item, i) => {
            const Icon = ICONS[i];
            const isFeatured = i === 0;
            const isAction = i === 4;
            return (
              <motion.div
                key={item.name}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className={`${cardClass} ${isFeatured ? "md:row-span-2 md:col-span-1" : ""} ${
                  isAction ? "md:col-span-2 bg-anthracite text-cream border-gold/40" : ""
                }`}
              >
                <div
                  className={`w-12 h-12 rounded-2xl flex items-center justify-center mb-6 transition-transform duration-500 group-hover:scale-110 ${
                    isAction ? "bg-gold/20 border border-gold/40" : "bg-gold/10 border border-gold/20"
                  }`}
                >
                  <Icon
                    size={22}
                    style={{ color: "#E5C76B" }}
                    strokeWidth={1.6}
                  />
                </div>

                <h3
                  className="font-accent italic text-3xl lg:text-4xl font-medium leading-none mb-4"
                  style={{ color: "#E5C76B" }}
                >
                  {item.name}
                </h3>

                <p
                  className={`text-[15px] leading-relaxed text-cream/90 ${isFeatured ? "max-w-sm" : ""}`}
                >
                  {item.desc}
                </p>

                {isFeatured && (
                  <div className="absolute right-5 bottom-5 text-7xl font-accent text-gold/20 leading-none select-none italic">
                    01
                  </div>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Values;
